import { useEffect, useMemo, useState } from 'react'
import { useStateValue } from '../modules/state-provider/StateProvider'

export type LivestreamStatus = 'countdown' | 'starting-soon' | 'live' | 'ended'

const STARTING_SOON_WINDOW_MS = 5 * 60_000 // 5 minutes after scheduled time

export function useLivestreamStatus(): {
  status: LivestreamStatus
  days: number
  hours: number
  minutes: number
} {
  const [{ liveStream, header }] = useStateValue()
  const [now, setNow] = useState(() => Date.now())

  const scheduledAt = liveStream?.scheduledAt
  const liveStreamUrl = header?.liveStreamUrl
  const scheduledMs = scheduledAt ? parseInt(scheduledAt) * 1000 : 0
  const diff = scheduledMs - now

  const status = useMemo<LivestreamStatus>(() => {
    if (liveStreamUrl) return 'live'
    if (!scheduledAt) return 'ended'
    if (diff > 60_000) return 'countdown'
    if (diff > -STARTING_SOON_WINDOW_MS) return 'starting-soon'
    return 'ended'
  }, [liveStreamUrl, scheduledAt, diff])

  useEffect(() => {
    if (status !== 'countdown' && status !== 'starting-soon') return
    const interval = setInterval(() => setNow(Date.now()), 1000)
    return () => clearInterval(interval)
  }, [status])

  return {
    status,
    days: Math.max(0, Math.floor(diff / 86_400_000)),
    hours: Math.max(0, Math.floor((diff % 86_400_000) / 3_600_000)),
    minutes: Math.max(0, Math.floor((diff % 3_600_000) / 60_000)),
  }
}
